/* eslint-disable */
import React, { useState } from "react";
import * as url from "helper/UrlHelper";
import { postData } from "utils/Gateway";
import { useTranslation } from "react-i18next";

const SearchFaqPopup = ({ afterPopupClose = () => {} }) => {
  const { t } = useTranslation();
  const token = localStorage.getItem("token");
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [faqList, setFaqList] = useState([]);
  const [faqError, setFaqError] = useState("");
  const [openContextIdx, setOpenContextIdx] = useState(null);
  const [faqAiSummary, setFaqAiSummary] = useState("");

  const handleSearch = async (e) => {
    e.preventDefault();
    setFaqError("");
    setFaqList([]);
    if (!searchTerm.trim()) {
      setFaqError("Please enter a search term.");
      return;
    }
    setIsSearching(true);
    try {
      // Replace with your actual search API endpoint
      let requestURL =
        url.API_BASE_URL + url.API_SEARCH_FAQ_BY_INDEX + `?token=${token}`;
      const payload = { query: searchTerm };
      const response = await postData(requestURL, payload);

      console.log("Search response:", response);

      if (
        response &&
        response.status &&
        Array.isArray(response.data.faqs) &&
        response.data.faqs.length > 0
      ) {
        setFaqList(response.data.faqs.slice(0, 3)); // Show up to 3 results
        setFaqAiSummary(response.data.summary?.summary ?? "");
        setFaqError("");
      } else {
        setFaqList([]);
        setFaqAiSummary("");
        setFaqError("No FAQs found for your search.");
      }
    } catch (err) {
      setFaqList([]);
      setFaqError("Failed to search FAQs. Please try again.");
    }
    setIsSearching(false);
  };

  const resetHandler = () => {
    setSearchTerm("");
    setFaqList([]);
    setFaqAiSummary("");
    setFaqError("");
    setOpenContextIdx(null);
    afterPopupClose();
  };

  return (
    <div
      className="offcanvas lg offcanvas-end bg-white border-0"
      tabIndex="-1"
      id="searchFaqOffcanvas"
      aria-labelledby="searchFaqOffcanvasLabel"
    >
      <div className="offcanvas-header bg-primary text-white p-4 pe-5 pb-3 border-bottom border-gray-300">
        <div className="d-flex align-items-center gap-3">
          <div className="icon-wrapper p-3 bg-white rounded-circle d-flex align-items-center justify-content-center">
            <span className="material-symbols-outlined text-primary fs-5 icon-md">
              search
            </span>{" "}
          </div>
          <div>
            <h3
              className="offcanvas-title fw-bold text-white mb-0"
              id="searchFaqOffcanvasLabel"
            >
              {t("Search FAQs")}
            </h3>
            <p className="text-white fs-sm mb-0">
              {t("Find answers to common questions")}
            </p>
          </div>
        </div>
        <button
          type="button"
          className="btn-close p-1 bg-gray-200 rounded-circle shadow-sm border-0"
          data-bs-dismiss="offcanvas"
          aria-label="Close"
          onClick={resetHandler}
        ></button>
      </div>
      <div className="offcanvas-body p-4">
        <form onSubmit={handleSearch} className="mb-4">
          <div className="form-group mb-4 p-3 border rounded-8 shadow-sm bg-white">
            <label
              htmlFor="searchTermInput"
              className="d-block fs-sm fw-semibold mb-2 text-dark"
            >
              {t("Search Term")}
            </label>
            <div className="input-group">
              <input
                type="text"
                id="searchTermInput"
                className="form-control fs-sm shadow-none border border-gray-300"
                placeholder={t("Enter search term")}
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                disabled={isSearching}
              />
              <button
                type="submit"
                className="btn btn-primary d-flex align-items-center gap-2"
                disabled={isSearching}
                style={{ minWidth: 120 }}
              >
                {isSearching ? (
                  <>
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                    {t("Searching...")}
                  </>
                ) : (
                  <>
                    <span className="material-symbols-outlined me-1">
                      search
                    </span>{" "}
                    {t("Search")}
                  </>
                )}
              </button>
              <button
                type="button"
                className="btn btn-outline-secondary d-flex align-items-center gap-2"
                style={{ minWidth: 120 }}
                onClick={resetHandler}
                disabled={isSearching}
              >
                <span className="material-symbols-outlined me-1">refresh</span>
                {t("Refresh")}
              </button>
            </div>
          </div>
        </form>
        {faqError && (
          <div className="alert alert-danger mt-2" role="alert">
            {faqError}
          </div>
        )}
        {isSearching ? (
          <div className="mt-4">
            {/* Glow placeholder for loading */}
            <div className="faq-list">
              {[1, 2, 3].map((i) => (
                <div key={i} className="mb-3 p-3 border rounded bg-light">
                  <div className="placeholder-glow mb-2">
                    <span className="placeholder col-8"></span>
                  </div>
                  <div className="placeholder-glow mb-2">
                    <span className="placeholder col-10"></span>
                  </div>
                  <div className="placeholder-glow mb-2">
                    <span className="placeholder col-6"></span>
                  </div>
                  <div className="placeholder-glow">
                    <span className="placeholder col-4"></span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ) : (
          faqList.length > 0 && (
            <div className="mt-4">
              <h6 className="fw-bold mb-3">Search Results</h6>
              {/* Show AI summary if available */}
              {faqAiSummary && (
                <div
                  className="mb-4 p-3 border border-primary rounded bg-light position-relative"
                  style={{ boxShadow: "0 0 0 0.15rem #0d6efd22" }}
                >
                  <span
                    className="badge bg-primary position-absolute"
                    style={{ top: 10, left: 10, zIndex: 2 }}
                  >
                    <span
                      className="material-symbols-outlined align-middle me-1"
                      style={{ fontSize: "1.1em", verticalAlign: "middle" }}
                    >
                      smart_toy
                    </span>
                    AI Suggestion
                  </span>
                  <div className="mt-3" style={{ fontStyle: "italic" }}>
                    {faqAiSummary}
                  </div>
                </div>
              )}
              <div className="faq-list">
                {faqList.map((faq, idx) => (
                  <div
                    key={idx}
                    className={`mb-3 p-3 border rounded bg-light ${
                      idx === 0
                        ? "border-primary border-3 position-relative"
                        : ""
                    }`}
                    style={
                      idx === 0 ? { boxShadow: "0 0 0 0.15rem #0d6efd33" } : {}
                    }
                  >
                    {idx === 0 && (
                      <span
                        className="badge bg-primary position-absolute"
                        style={{ top: 12, right: 18, zIndex: 2 }}
                      >
                        Best Match
                      </span>
                    )}
                    <div className="fw-semibold mb-1 text-primary">
                      Q{idx + 1}: {faq.question}
                    </div>
                    <div className="mb-1">
                      <span className="fw-semibold">A:</span> {faq.answer}
                    </div>
                    {/* Show context if present, as page info */}
                    {faq.context && (
                      <div className="mb-1">
                        <span className="fw-semibold">Context:</span>{" "}
                        <span className="text-muted">Page {faq.context}</span>
                      </div>
                    )}

                    {faq.referencedocument && (
                      <div className="mt-2">
                        <span className="fw-semibold">Reference Document:</span>
                        <div className="d-flex align-items-center gap-2">
                          <span className="text-muted">
                            {faq.referencedocument?.name}
                          </span>
                          <a
                            href={url.SERVER_URL + faq.referencedocument?.path}
                            download
                            target="_blank"
                            rel="noopener noreferrer"
                            className="btn btn-link p-0"
                            title="Download"
                            style={{ fontSize: "1.2em" }}
                          >
                            <span className="material-symbols-outlined align-middle">
                              download
                            </span>
                          </a>
                        </div>
                      </div>
                    )}
                    {faq.page && (
                      <div className="text-muted" style={{ fontSize: "0.9em" }}>
                        <span className="me-2">Page: {faq.page}</span>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )
        )}
      </div>
    </div>
  );
};

export default SearchFaqPopup;
